import React, { useState } from 'react';
import AMPageShell from './components/AMPageShell';
import Icon from 'components/AppIcon';
import { ASSETS } from './data/assetData';

export default function CounterpartyDirectory({ selectedAssets, showToast }) {
  const assets = selectedAssets || ASSETS;
  const [activeAssetId, setActiveAssetId] = useState(assets?.[0]?.id);
  const [activeTab, setActiveTab] = useState('counterparties');
  const asset = assets?.find((a) => a?.id === activeAssetId) || assets?.[0];

  if (!asset) return <AMPageShell activeTab="/asset-management/counterparty-directory"><p className="text-muted-foreground font-caption">No assets selected.</p></AMPageShell>;

  const ContactCard = ({ contact, showType = false }) => (
    <div className="bg-card border border-border rounded-md p-4">
      <div className="flex items-start justify-between mb-2">
        <div>
          <p className="font-caption text-sm font-semibold text-foreground">{contact?.name}</p>
          <p className="font-caption text-xs text-muted-foreground">{showType ? contact?.type : contact?.role}</p>
        </div>
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="User" size={14} color="var(--color-primary)" strokeWidth={2} />
        </div>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <Icon name="Mail" size={12} color="var(--color-muted-foreground)" strokeWidth={2} />
          <span className="font-caption text-xs text-foreground">{contact?.contact || contact?.email}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Phone" size={12} color="var(--color-muted-foreground)" strokeWidth={2} />
          <span className="font-caption text-xs text-foreground">{contact?.phone}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={12} color="var(--color-muted-foreground)" strokeWidth={2} />
          <span className="font-caption text-xs text-muted-foreground">Last contacted: {contact?.lastContacted}</span>
        </div>
        {contact?.notes && (
          <div className="mt-2 pt-2 border-t border-border">
            <p className="font-caption text-xs text-muted-foreground">{contact?.notes}</p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <AMPageShell activeTab="/asset-management/counterparty-directory">
      <div className="flex gap-6">
        <div className="w-48 flex-shrink-0">
          <div className="bg-card border border-border rounded-lg shadow-xs overflow-hidden">
            <div className="px-4 py-3 border-b border-border">
              <p className="font-caption text-xs font-semibold text-muted-foreground uppercase tracking-wide">Asset</p>
            </div>
            {assets?.map((a) => (
              <button key={a?.id} onClick={() => setActiveAssetId(a?.id)}
                className={`w-full text-left px-4 py-2.5 transition-colors ${
                  a?.id === activeAssetId ? 'bg-primary/5 border-l-2 border-primary' : 'hover:bg-muted/40'
                }`}>
                <p className="font-caption text-sm font-medium text-foreground truncate">{a?.name}</p>
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="bg-card border border-border rounded-lg shadow-xs overflow-hidden">
            <div className="px-6 py-4 border-b border-border">
              <h2 className="font-heading font-semibold text-foreground" style={{ fontSize: '1.1rem' }}>{asset?.name}</h2>
              <div className="flex gap-4 mt-3">
                {[{ key: 'counterparties', label: 'Counterparties' }, { key: 'internal', label: 'Internal Contacts' }]?.map((t) => (
                  <button key={t?.key} onClick={() => setActiveTab(t?.key)}
                    className={`text-sm font-caption font-medium pb-2 border-b-2 transition-all duration-250 ${
                      activeTab === t?.key ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'
                    }`}>
                    {t?.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="p-6">
              {activeTab === 'counterparties' ? (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  {asset?.counterparties?.map((c, i) => <ContactCard key={i} contact={c} showType />)}
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  {asset?.internalContacts?.map((c, i) => <ContactCard key={i} contact={c} />)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </AMPageShell>
  );
}
